/** Textos reutilizables de roles (ajustar si cambian en Administrador → Usuarios). */
export const ROLES = {
  admin:
    'Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.',
  limitado:
    'Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil.',
  contador: 'Contador: acceso orientado a Contabilidad y reportes autorizados; no opera inventario.',
  ventas: 'Ventas: requiere módulo Ventas activo y punto de venta asignado (usuarios limitados).',
  almacenes:
    'Almacenes: requiere acceso al módulo de inventario; usuarios limitados solo ven almacenes asignados y operan guías según permiso (no solo lectura).',
  produccion:
    'Producción: módulo Producción activo; usuarios limitados necesitan permiso de producción, concesionaria o restaurantes según configuración.',
  concesionaria:
    'Producción concesionaria: flags de concesionaria o venta-operaciones activos; usuarios limitados con permiso producción_concesionaria.',
};

export const SHOTS = {
  vistaGeneral: 'Vista general de la pantalla con menú lateral y área de trabajo.',
  formularioCompleto: 'Formulario completo con cabecera, grilla de ítems y botones de acción al pie.',
  listado: 'Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.',
  confirmacion: 'Mensaje de confirmación o toast tras guardar correctamente.',
};
